import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[idpRightRailScroll]'
})
export class RightRailScrollDirective {
  scrollRange!: number;
  isPrevMediaLg!: boolean;

  constructor(private el: ElementRef) {}

  @HostListener('window:scroll', []) onWindowScroll() {
    if (this.isLargerScreenMedia()) {
      this.scroll();
    }
  }

  @HostListener('window:resize', []) onResize() {
    this.resized();
  }

  isLargerScreenMedia = () => window.matchMedia('(min-width : 1200px)').matches;

  resized = (): void => {
    if (this.mediaScreenLarge()) {
      this.scroll();
      this.el.nativeElement.classList.remove('sticky-btm');
    } else if (this.prevMediaLg()) {
      this.scroll();
      this.el.nativeElement.classList.remove('sticky');
      this.el.nativeElement.classList.remove('non-sticky');
    }
    this.isPrevMediaLg = this.isLargerScreenMedia();
  };

  mediaScreenLarge() {
    return this.isLargerScreenMedia() && !this.isPrevMediaLg;
  }

  prevMediaLg() {
    return !this.isLargerScreenMedia() && this.isPrevMediaLg;
  }

  scroll = (): void => {
    if (this.el.nativeElement !== undefined && this.el.nativeElement !== null) {
      const nativeElement = this.el.nativeElement;
      const tripTotalParentTop = nativeElement.offsetTop;
      const tripTotalParentHeight = nativeElement.offsetHeight;
      const tripTotalHeight = (
        nativeElement.querySelector('.right-rail-wrapper') as HTMLElement
      ).offsetHeight;
      this.scrollRange =
        tripTotalParentHeight + tripTotalParentTop - tripTotalHeight;
      if (this.isLargerScreenMedia()) {
        this.getStickyClasses(tripTotalParentTop);
      } else {
        this.getSticktyBottomClass(tripTotalParentTop, tripTotalParentHeight);
      }
    }
  };

  getStickyClasses(tripTotalParentTop: number) {
    const rightRailClassList = this.el.nativeElement.classList;
    if (window.pageYOffset < tripTotalParentTop) {
      rightRailClassList.remove('sticky');
      rightRailClassList.remove('non-sticky');
    } else if (window.pageYOffset <= this.scrollRange) {
      rightRailClassList.add('sticky');
      rightRailClassList.remove('non-sticky');
    } else {
      rightRailClassList.add('non-sticky');
      rightRailClassList.remove('sticky');
    }
  }

  getSticktyBottomClass(
    tripTotalParentTop: number,
    tripTotalParentHeight: number
  ) {
    const rightRailClassList = this.el.nativeElement.classList;
    if (
      tripTotalParentTop + tripTotalParentHeight >=
      window.pageYOffset + window.innerHeight
    ) {
      rightRailClassList.add('sticky-btm');
    } else {
      rightRailClassList.remove('sticky-btm');
    }
  }
}
